/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/api.service';
import { ConnectService } from 'src/app/services/connect.service';

@Component({
  selector: 'app-connect-popup',
  templateUrl: './connect-popup.component.html',
  styleUrls: ['./connect-popup.component.scss']
})
export class ConnectPopupComponent implements OnInit{
  requestsFor:any[]=['Catalogue','Price list','Retailers list','Contact representative'];
  cities: any;
  submitted = false;
  // showMobileOtp:boolean
  // showEmailOtp:boolean;
  // mobileOtpError:string;
  // isMobileVerified:boolean;
  // isEmailVerified:boolean;
  // interval: any;
  // timer:any;
  constructor(@Inject(PLATFORM_ID) private platformId: object,public _as:AppService,public _connect:ConnectService,private _router:Router, private _fb:FormBuilder,private _toastr:ToastrService){}
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    this._connect.connectForm=this._fb.group({
      // 'name':new FormControl('',[Validators.required, Validators.pattern="[A-Za-z\s]+"]),
      'name':new FormControl('',[Validators.required]),
      'last_name':new FormControl(''),
      'email':new FormControl(''),
      'mobile':new FormControl('',[Validators.required,Validators.minLength(10), Validators.pattern(/^[0-9+-]*$/)]),
      'user_type':new FormControl('',[Validators.required]),
      'subject':new FormArray([],[Validators.required]),
      'message':new FormControl('',[Validators.required]),
      'city':new FormControl('',[Validators.required]),
      'business_name':new FormControl(''),
      'pincode':new FormControl('',[Validators.required])
    })
 
  }
  }
  search(event:any) {
    const url = this._as.api_base_url + 'renovarz/city/?value=' + event.query;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this.cities = res;
      });
  }
  // oncityselect(event:any) {
  //   console.log(event)
  //   this.connectForm.controls['city'].setValue(event.id)
  //   // this.connectForm.controls['state'].setValue(event.state)
  // }

  get f(){
    return this._connect.connectForm.controls
  }

  onClosePopup(){
    this._connect.connectForm.reset();
    this._connect.displayConnect=false;
  }

  onChange(e:any){
    const checked=(e.target as HTMLInputElement).checked
    const value=(e.target as HTMLInputElement).value;
    const requestArray=this._connect.connectForm.get('subject') as FormArray;
    if(checked){
      requestArray.push(new FormControl(value))
    }else{
      let i=0;
      requestArray.controls.forEach((item:any)=>{
        if(item.value==value){
          requestArray.removeAt(i);
        }
        i++;
      })
    }
  }

  // onSendOtp(key:string){
  //   if(key=='mobile'){

  //   }
  // }

  // startTimer(minute:number) {
  //   let seconds: number = minute * 60;
  //   let textSec: any = "0";
  //   let statSec = 60;
  //   const prefix = minute < 10 ? "0" : "";
  //   this.timer = setInterval(() => {
  //     seconds--;
  //     if (statSec != 0) statSec--;
  //     else statSec = 59;

  //     if (statSec < 10) {
  //       textSec = "0" + statSec;
  //     } else textSec = statSec;

  //     this.interval = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

  //     if (seconds == 0) {
  //       this.interval = 0;
  //       clearInterval(this.timer);
  //     }
  //   }, 1000);
  // }
  // onVerifyOtp(otp:string, key: string) {
    
  // }

  onSend(data:any){
    this.submitted=true;
    if(this._connect.connectForm.invalid){
      return
    }
    if (data.user_type && typeof data.user_type === 'object') {
      data.user_type = data.user_type.name;
    }
    if (data.city && typeof data.city === 'object') {
      data.city = data.city.id;
    }
    if(this._router.url.includes('brand')){
      data.brand=this._connect.connectData.id
      data.form_type="brand_connect";
    }else if(this._router.url.includes('dealer')){
      data.dealer=this._connect.connectData.id
      data.form_type="dealer_connect";
    }else{
      data.product=this._connect.connectData.id
      data.form_type="product_connect";
    }
    const url = this._as.api_base_url + '/user/contactus/'
    this._as.postRequest(url,data,false).subscribe((res:any)=>{
      console.log(res)
      this._connect.connectForm.reset();
      const subjectArray = this._connect.connectForm.get('subject') as FormArray;
      subjectArray.clear(); 
      this.submitted=false;
      this._connect.displayConnect=false;
      this._connect.connectData=undefined;
      this._connect.productPageSubject=undefined;
      this._toastr.success('Your request has been correctly sent');
    })
  }
}
